import { Checkbox as MuiCheckbox, FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import { CheckSquare, MinusSquare, Square } from '@phosphor-icons/react'
import { tokens } from 'ComponentLibrary'
import { SyntheticEvent } from 'react'
import { TextWithEllipsis, Typography } from '../../text'

export type CheckboxPropTypes = {
    label?: string
    checked?: boolean
    indeterminate?: boolean
    disabled?: boolean
    ellipsis?: boolean
    ariaLabel?: string
    emphasized?: boolean
    onChange?: (event: SyntheticEvent<Element, Event>, checked: boolean) => void
}

export function Checkbox({
    label,
    checked,
    disabled = false,
    onChange,
    indeterminate,
    ellipsis,
    ariaLabel,
    emphasized,
}: CheckboxPropTypes) {
    if (label) {
        return (
            <StyledFormControlLabel
                label={
                    ellipsis ? (
                        <TextWithEllipsis
                            tooltipText={label}
                            typographyProps={{
                                variant: 'textM',
                                color: disabled ? tokens.ColorTextDisabled : tokens.ColorTextBold,
                            }}
                            placement="right"
                        >
                            {label}
                        </TextWithEllipsis>
                    ) : (
                        <Typography variant="textM" color={disabled ? tokens.ColorTextDisabled : tokens.ColorTextBold}>
                            {label}
                        </Typography>
                    )
                }
                control={
                    <StyledCheckbox
                        checked={checked}
                        indeterminate={indeterminate}
                        icon={<Square size={tokens.SizingIconM} weight={emphasized ? 'bold' : 'regular'} />}
                        checkedIcon={<CheckSquare size={tokens.SizingIconM} weight="fill" />}
                        indeterminateIcon={<MinusSquare size={tokens.SizingIconM} weight="fill" />}
                        disableRipple
                        inputProps={{ 'aria-label': ariaLabel }}
                    />
                }
                disabled={disabled}
                onChange={onChange}
                disableTypography
            />
        )
    }
    return (
        <StyledCheckbox
            checked={checked}
            indeterminate={indeterminate}
            icon={<Square size={tokens.SizingIconM} weight={emphasized ? 'bold' : 'regular'} />}
            checkedIcon={<CheckSquare size={tokens.SizingIconM} weight="fill" />}
            indeterminateIcon={<MinusSquare size={tokens.SizingIconM} weight="fill" />}
            disableRipple
            disabled={disabled}
            onChange={onChange}
            inputProps={{ 'aria-label': ariaLabel }}
        />
    )
}

const StyledCheckbox = styled(MuiCheckbox)({
    padding: 0,
    color: tokens.ColorIconDisabled,
    '&:hover:not(.Mui-disabled)': {
        color: tokens.ColorIconLinkHover,
    },
    '&.Mui-checked:not(:hover):not(.Mui-disabled), &.MuiCheckbox-indeterminate:not(:hover):not(.Mui-disabled)': {
        color: tokens.ColorIconLinkSelected,
    },
})

const StyledFormControlLabel = styled(FormControlLabel)({
    maxWidth: 'inherit',
    gap: tokens.SizingSpacing100,
    alignItems: 'flex-start',
    marginRight: 0,
    marginLeft: 0,
    '&:hover': {
        '.MuiCheckbox-root:not(.Mui-disabled), .MuiCheckbox-root.Mui-checked:not(.Mui-disabled), .MuiCheckbox-root.MuiCheckbox-indeterminate:not(.Mui-disabled)':
            {
                color: tokens.ColorIconLinkHover,
            },
    },
})
